<template lang="pug">
BriqDialog(v-show="show" @close="$emit('close')" @after-close="afterClose")
  h2.mb-S Register payment
  BriqMultiselect.mb-S(
    label="Payment method"
    :options="retreivedExternalPaymentMethods"
    display="DisplayName"
    track-by="Name"
    v-model="dialogModel.PaymentMethod"
    required
    :disabled="disabled"
    :error="paymentMethodError"
    data-test-id="payment-method"
    )
  BriqPriceInput.mb-S(
    label="Amount"
    type="number"
    min="0"
    v-model.number="dialogModel.Amount"
    :currencySymbol="currencySymbol"
    required
    :disabled="disabled"
    :error="amountError"
    data-test-id="payment-input"
    )
  BriqTextarea.mb-S(
    label="Description"
    v-model="dialogModel.Description"
    :disabled="disabled"
    data-test-id="payment-description"
    )
  .dialog-actions
    BriqButton.mr-5(@click="$emit('close')" variant="text" :disabled="disabled") Cancel
    BriqButton.ml-5(@click="addPayment" :disabled="disabled" data-test-id="register-button") Register
</template>

<script>
import { mapGetters } from 'vuex'
import { path } from 'ramda'
import ExternalPaymentApiModel from '@v/bookings/details/ExternalPaymentApiModel.js'
import { required, minValue } from 'vuelidate/lib/validators'
import BriqPriceInput from '@v/components/BriqPriceInput.vue'
import { currencySymbol } from '@/helpers/intlFormatter.js'

export default {
  name: 'AddPaymentDialog',
  components: { BriqPriceInput },
  props: {
    show: Boolean,
    disabled: Boolean,
    outstandingAmount: Number,
  },
  data() {
    return {
      dialogModel: {
        PaymentMethod: null,
        Amount: this.show ? this.outstandingAmount : 0,
        Description: null,
      },
    }
  },
  validations() {
    return {
      dialogModel: {
        PaymentMethod: { required },
        Amount: { required, minValue: minValue(0) },
      },
    }
  },
  computed: {
    ...mapGetters('bookingDetails', ['externalPaymentMethods']),
    firstPaymentOption() {
      return path([0, 'Name'])(this.externalPaymentMethods)
    },
    retreivedExternalPaymentMethods() {
      return this.externalPaymentMethods !== undefined ? this.externalPaymentMethods : []
    },
    amountError() {
      return this.$v.dialogModel.Amount.$error ? 'Amount is required' : null
    },
    paymentMethodError() {
      return this.$v.dialogModel.PaymentMethod.$error ? 'Payment method is required' : null
    },
    currencySymbol() {
      return currencySymbol(this.$locale, this.$currency)
    },
  },
  methods: {
    addPayment() {
      this.$v.$touch()
      if (this.$v.$error) return
      const saveModel = new ExternalPaymentApiModel(this.dialogModel)
      this.$emit('save', saveModel)
    },
    afterClose() {
      this.dialogModel.PaymentMethod = this.firstPaymentOption
      this.dialogModel.Amount = 0
      this.dialogModel.Description = null
      this.$v.$reset()
    },
  },
  watch: {
    show(v) {
      if (v) {
        this.dialogModel.PaymentMethod = this.firstPaymentOption
        this.dialogModel.Amount = this.outstandingAmount
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.dialog-actions
  display flex
  justify-content center
</style>
